import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { DeleteOutline } from "@mui/icons-material";
import {
  Button,
  Grid,
  Typography,
  IconButton,
  Tooltip,
  MenuItem,
} from "@mui/material";

import { TextField } from "../../../../components";
import { useAxios } from "../../../../hooks";

export default function UpdateLead({ fields, formikProps, editState }) {
  const axios = useAxios();
  const [dataType, setDataType] = useState("");
  const [operators, setOperators] = useState([]);
  const [nameError, setNameError] = useState("");

  const { ID } = useSelector((state) => state.memberDetails.activeBot);

  useEffect(() => {
    axios({
      url: "/workflow/action/operators/" + ID,
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setOperators(response.data);
      }
    });
  }, [axios, ID]);

  async function addVariables() {
    if (!formikProps.values.variables) {
      await formikProps.setValues((prev) => ({
        ...prev,
        variables: [],
      }));
    }
    formikProps.setValues((prev) => ({
      ...prev,
      variables: [
        ...prev.variables,
        { variable_name: "", variable_value: "", operator: "" },
      ],
    }));
  }

  function handleChange(e, index) {
    setNameError({ ...nameError, [index]: "" });

    if (dataType === "string" && !isNaN(e.target.value)) {
      setNameError({ ...nameError, [index]: "Invalid string data type" });
      return;
    }

    if (dataType === "integer" && isNaN(e.target.value)) {
      setNameError({ ...nameError, [index]: "Invalid integer data type" });
      return;
    }

    let values = [...formikProps.values.variables];
    values[index].variable_value = e.target.value;

    formikProps.setValues((prev) => ({
      ...prev,
      variables: [...values],
    }));
  }

  function handleVariableChange(e, index) {
    let { dataType } = fields.filter(
      (field) => field.name === e.target.value
    )[0];

    setDataType(dataType);

    let values = [...formikProps.values.variables];
    values[index].variable_name = e.target.value;

    formikProps.setValues((prev) => ({
      ...prev,
      variables: [...values],
    }));
  }

  return (
    <Fragment>
      <Grid item xs={8}>
        <Typography variant="h5">Variables</Typography>
      </Grid>

      <Grid item xs={4} textAlign={"end"}>
        {editState && (
          <Button variant="outlined" onClick={() => addVariables()}>
            Add Variables
          </Button>
        )}
      </Grid>

      {formikProps.values?.variables?.map((_, index) => (
        <Fragment>
          <Grid item xs={2}>
            <TextField
              select
              label={"Variable Name"}
              name={"variables." + [index] + ".variable_name"}
              formikProps={formikProps}
              disabled={!editState}
              onChange={(e) => handleVariableChange(e, index)}
            >
              {fields.map((item) => (
                <MenuItem key={item.name} value={item.name}>
                  {item.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={2}>
            <TextField
              select
              formikProps={formikProps}
              label="Operator"
              name={"variables." + [index] + ".operator"}
              disabled={!editState}
            >
              {operators.map((op) => (
                <MenuItem key={op.name} value={op.name}>
                  {op.value}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          {dataType === "boolean" && (
            <Grid item xs={2}>
              <TextField
                select
                onChange={(e) => handleChange(e, index)}
                formikProps={formikProps}
                label="Variable Value"
                name={"variables." + [index] + ".variable_value"}
                disabled={!editState}
                helperText={nameError[index] ? nameError[index] : ""}
              >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </TextField>
            </Grid>
          )}

          {dataType !== "boolean" && (
            <Grid item xs={2}>
              <TextField
                onKeyUp={(e) => handleChange(e, index)}
                formikProps={formikProps}
                label="Variable Value"
                name={"variables." + [index] + ".variable_value"}
                disabled={!editState}
                helperText={nameError[index] ? nameError[index] : ""}
              />
            </Grid>
          )}

          <Grid item xs={1} alignSelf={"center"} textAlign={"start"}>
            {editState && (
              <Tooltip title="Delete variable">
                <IconButton onClick={() => handleDeleteVariable(index)}>
                  <DeleteOutline color="error" />
                </IconButton>
              </Tooltip>
            )}
          </Grid>

          <Grid item xs={12} />
        </Fragment>
      ))}
    </Fragment>
  );

  function handleDeleteVariable(index) {
    let vals = [...formikProps.values.variables];
    vals.splice(index, 1);
    formikProps.setValues((prev) => ({
      ...prev,
      variables: vals,
    }));
  }
}
